import React from 'react';
import { Skeleton } from '@planne-software/uni';

import { useCheckoutPageClassNameSwap } from './hooks/useCheckoutPageClassNameSwap';
import {
  CheckoutHeaderRow,
  CheckoutPageShell,
  LayoutRoot,
  MainColumn,
  SidebarColumn,
  SkeletonCard,
  SkeletonRow,
  SkeletonStack,
} from './styles';

const OPTION_ROWS = ['first', 'second', 'third', 'fourth'];

export const CheckoutStepSkeleton = () => {
  return (
    <SkeletonStack role='status' aria-busy='true' data-testid='checkout-step-skeleton'>
      <SkeletonCard>
        <Skeleton variant='rounded' sx={{ maxWidth: '30%', height: '1rem' }} />
        <Skeleton variant='rounded' sx={{ maxWidth: '55%', height: '1rem' }} />
      </SkeletonCard>

      <SkeletonCard>
        <Skeleton variant='rounded' sx={{ maxWidth: '35%', height: '1.25rem' }} />
        <Skeleton variant='rounded' sx={{ maxWidth: '60%', height: '1rem' }} />

        {OPTION_ROWS.map((row) => (
          <SkeletonRow key={row}>
            <Skeleton variant='circular' sx={{ width: '1.25rem', height: '1.25rem' }} />
            <Skeleton variant='rounded' sx={{ maxWidth: '100%', height: '3rem' }} />
          </SkeletonRow>
        ))}

        <Skeleton variant='rounded' sx={{ maxWidth: '40%', height: '0.875rem' }} />
      </SkeletonCard>
    </SkeletonStack>
  );
};

export const CheckoutSidebarSkeleton = () => (
  <SkeletonCard data-testid='checkout-sidebar-skeleton'>
    <Skeleton variant='rounded' sx={{ maxWidth: '45%', height: '1.25rem' }} />
    <Skeleton variant='rounded' sx={{ maxWidth: '100%', height: '1rem' }} />
    <Skeleton variant='rounded' sx={{ maxWidth: '100%', height: '1rem' }} />
    <Skeleton variant='rounded' sx={{ maxWidth: '70%', height: '1.5rem' }} />
  </SkeletonCard>
);

export const CheckoutShellSkeleton = () => {
  useCheckoutPageClassNameSwap();

  return (
    <CheckoutPageShell data-testid='checkout-shell-skeleton'>
      <CheckoutHeaderRow>
        <Skeleton variant='circular' sx={{ width: '2.25rem', height: '2.25rem' }} />
        <Skeleton variant='rounded' sx={{ maxWidth: '12rem', height: '1.75rem' }} />
      </CheckoutHeaderRow>

      <LayoutRoot>
        <MainColumn data-full='false'>
          <CheckoutStepSkeleton />
        </MainColumn>

        <SidebarColumn>
          <CheckoutSidebarSkeleton />
        </SidebarColumn>
      </LayoutRoot>
    </CheckoutPageShell>
  );
};

export default CheckoutStepSkeleton;
